import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';
import { getAllTestSubmission } from '../../../../service/test.submission.service';
import { API_LIMIT_DATA } from '../../../../utils/constants';
import UserIcon from '../../../../svg/UserIcon';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import MarkingSchema from '../../../../components/MarkingSchema';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import '../../../../css/upcomingTest.css';
import UploadPaper from './Teacher.UploadPaper';
import PageIcon from '../../../../svg/PageIcon';
import StudentList from './Teacher.StudentList';
import Header from '../../../../components/Header';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';

export default function PreviousTestDetails({ testDetails, onBack }) {
  const {
    id,
    name,
    type,
    createdAt,
    startDate,
    startTime,
    duration,
    incorrectMark,
    correctMark,
    totalMark
  } = testDetails;
  const [selectedScreen, setSelScreen] = useState(null);
  const [offset, setOffset] = useState(1);
  const [hasMore, setHasMore] = useState();
  const [submissionList, setSubmissionList] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  // open dialog
  const [solutionDialog, setSolutionDialog] = useState(false);

  const fetchTestSubmissionList = async () => {
    await getAllTestSubmission(id, API_LIMIT_DATA, offset).then((res) => {
      setSubmissionList(res.results);
      setHasMore(res.results.length === API_LIMIT_DATA);
      setOffset(offset + 1);
    });
  };

  const fetchNextData = async () => {
    if (hasMore) {
      const res = await getAllTestSubmission(id, API_LIMIT_DATA, offset);
      if (res) {
        setSubmissionList((preResource) => [...preResource, ...res.results]);
        setHasMore(res.results.length === API_LIMIT_DATA);
        setOffset(offset + 1);
      }
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    fetchTestSubmissionList();
  }, []);

  return (
    <div style={{ marginTop: 20 }}>
      {/* eslint-disable-next-line */}
      {selectedScreen === null ? (
        <>
          <Header title={name} onBack={onBack} />
          <TestInfoCard
            createdOn={moment(createdAt).format('DD MMM, LT')}
            startTime={moment(startDate).format('DD MMM, LT')}
            endTime={`${moment(startDate).format('DD MMM,')} ${moment(startTime)
              .add(duration, 'minutes')
              .format('LT')}`}
            duration={`${duration} minutes`}
            questions={type === 'type' ? testDetails.questions.length : null}
            marks={totalMark}
          />
          <MarkingSchema
            correctAns={`+${correctMark}`}
            incorrectAns={incorrectMark < 0 ? `-${incorrectMark}` : incorrectMark}
          />
          {type === 'upload' && testDetails?.typeURL && (
            <Card style={{ marginTop: 15 }}>
              <CardHeader title="Download the test paper" />
              <CardContent>
                <DownloadFileContainer title={testDetails?.typeURL} isDownload />
              </CardContent>
            </Card>
          )}
          {testDetails?.isSolutionUploaded && (
            <Card style={{ marginTop: 15 }}>
              <CardHeader title="Your solution" />
              <CardContent>
                <DownloadFileContainer
                  title={testDetails?.solutionURL}
                  fileLink={testDetails?.solutionURL}
                  isDownload
                />
              </CardContent>
            </Card>
          )}
          <Card style={{ marginTop: 15 }}>
            <CardContent>
              <NameAndChangeToScreenCard
                title="Students Answers"
                subTitle={
                  <>
                    <UserIcon
                      style={{ marginRight: 5 }}
                      color={palette.grey[500]}
                      width={12}
                      height={12}
                    />{' '}
                    {submissionList.length}
                  </>
                }
                icon={<PageIcon color={palette.secondary.main} />}
                onClick={() => setSolutionDialog(true)}
              />
            </CardContent>
          </Card>
        </>
      ) : selectedScreen === 'students' ? (
        <StudentList
          title={name}
          onBack={() => setSelScreen(null)}
          studentList={submissionList}
          fetchMore={fetchNextData}
          hasMore={hasMore}
          isDataLoading={isDataLoading}
          setIsDataLoading={setIsDataLoading}
        />
      ) : (
        <UploadPaper onBack={() => setSelScreen(null)} />
      )}

      <Dialog fullWidth open={solutionDialog} onClose={() => setSolutionDialog(false)}>
        <DialogTitle>Submission List</DialogTitle>
        <DialogContent>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (hasMore && !isDataLoading) {
                fetchNextData();
                setIsDataLoading(true);
              }
            }}
            getScrollParent={() => document.getElementById('scrollableCard')}
            hasMore={hasMore}
            loader={
              <Box my={2} display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            }
            useWindow={false}
          >
            {submissionList.length === 0 && (
              <Typography textAlign="center">No submissions</Typography>
            )}
            {submissionList.map((sl) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                textAlign="center"
                key={sl?.id ?? sl?._id}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar
                    alt={sl.studentId.fullName}
                    src={sl.studentId.profileImage}
                    sx={{ mr: 2 }}
                  />
                  <Typography variant="subtitle2" noWrap>
                    {sl.studentId.fullName}
                  </Typography>
                  {/* <Typography variant="subtitle2" noWrap>
                    - {sl.totalMark}/{totalMark}
                  </Typography> */}
                </Stack>
                <Button
                  onClick={() =>
                    window.open(
                      `${window.location.origin}/dashboard/test/${testDetails?.id}/result/${
                        sl?.id ?? sl?._id
                      }`
                    )
                  }
                >
                  Detail
                </Button>
              </Stack>
            ))}
          </InfiniteScroll>
        </DialogContent>
      </Dialog>
    </div>
  );
}

PreviousTestDetails.propTypes = {
  testDetails: PropTypes.object,
  onBack: PropTypes.func
};
